const actions = {
  SINGLE_PRODUCT_ADDON_BEGIN: 'SINGLE_PRODUCT_ADDON_BEGIN',
  SINGLE_PRODUCT_ADDON_SUCCESS: 'SINGLE_PRODUCT_ADDON_SUCCESS',
  SINGLE_PRODUCT_ADDON_ERR: 'SINGLE_PRODUCT_ADDON_ERR',

  EDIT_ADDON_BEGIN: 'EDIT_ADDON_BEGIN',
  EDIT_ADDON_SUCCESS: 'EDIT_ADDON_SUCCESS',
  EDIT_ADDON_ERR: 'EDIT_ADDON_ERR',

  ADD_ADDON_BEGIN: 'ADD_ADDON_BEGIN',
  ADD_ADDON_SUCCESS: 'ADD_ADDON_SUCCESS',
  ADD_ADDON_ERR: 'ADD_ADDON_ERR',

  DISABLE_ADDON_BEGIN: 'DISABLE_ADDON_BEGIN',
  DISABLE_ADDON_SUCCESS: 'DISABLE_ADDON_SUCCESS',
  DISABLE_ADDON_ERR: 'DISABLE_ADDON_ERR',

  PRODUCT_ADDONS_BEGIN: 'PRODUCT_ADDONS_BEGIN',
  PRODUCT_ADDONS_SUCCESS: 'PRODUCT_ADDONS_SUCCESS',
  PRODUCT_ADDONS_ERR: 'PRODUCT_ADDONS_ERR',

  singleAddonBegin: () => {
    return {
      type: actions.SINGLE_PRODUCT_ADDON_BEGIN,
    };
  },

  singleAddonSuccess: (data) => {
    return {
      type: actions.SINGLE_PRODUCT_ADDON_SUCCESS,
      data,
    };
  },

  singleAddonErr: (err) => {
    return {
      type: actions.SINGLE_PRODUCT_ERR,
      err,
    };
  },

  addonsBegin: () => {
    return {
      type: actions.PRODUCT_ADDONS_BEGIN,
    };
  },

  addonsSuccess: (data) => {
    return {
      type: actions.PRODUCT_ADDONS_SUCCESS,
      data,
    };
  },

  addonsErr: (err) => {
    return {
      type: actions.PRODUCT_ADDONS_ERR,
      err,
    };
  },

  editAddonBegin: () => {
    return {
      type: actions.EDIT_ADDON_BEGIN,
    };
  },

  editAddonSuccess: (data) => {
    return {
      type: actions.EDIT_ADDON_SUCCESS,
      data,
    };
  },

  editAddonErr: (err) => {
    return {
      type: actions.EDIT_ADDON_ERR,
      err,
    };
  },

  addAddonBegin: () => {
    return {
      type: actions.ADD_ADDON_BEGIN,
    };
  },

  addAddonSuccess: (data) => {
    return {
      type: actions.ADD_ADDON_SUCCESS,
      data,
    };
  },

  addAddonErr: (err) => {
    return {
      type: actions.ADD_ADDON_ERR,
      err,
    };
  },

  disableAddonBegin: (id) => {
    return {
      type: actions.DISABLE_ADDON_BEGIN,
      id,
    };
  },

  disableAddonSuccess: (id) => {
    return {
      type: actions.DISABLE_ADDON_SUCCESS,
      id,
    };
  },

  disableAddonErr: (id) => {
    return {
      type: actions.DISABLE_ADDON_ERR,
      id,
    };
  },
};

export default actions;
